/* projects/shared/layouts/responsive-nav-bar/shared-sidebar-list/shared-sidebar-list.scss */
:root {
  --rounded-border-top: var(--space-s) var(--space-s) 0px 0px;
  --rounded-border-bottom: 0px 0px var(--space-s) var(--space-s);
}
shared-sidebar-list,
:host {
  display: flex;
  flex-direction: column;
}
shared-sidebar-list .mat-tree,
:host .mat-tree {
  display: grid;
  background: transparent;
}
shared-sidebar-list .mat-tree .mat-tree-node,
:host .mat-tree .mat-tree-node {
  width: var(--sidebar-item-width);
  display: block;
  min-height: unset;
  height: var(--space-xxl);
}
shared-sidebar-list .mat-tree .mat-tree-node.root-node.accordion-node[aria-expanded=true],
:host .mat-tree .mat-tree-node.root-node.accordion-node[aria-expanded=true] {
  border-radius: var(--rounded-border-top);
  background-color: var(--sidebar-selected-color);
}
shared-sidebar-list .mat-tree .mat-tree-node.child-node,
:host .mat-tree .mat-tree-node.child-node {
  height: var(--space-xxl);
  background-color: var(--sidebar-selected-color);
}
shared-sidebar-list .mat-tree .mat-tree-node.child-node .sidebar-item-label,
:host .mat-tree .mat-tree-node.child-node .sidebar-item-label {
  padding-left: 20px;
}
shared-sidebar-list .mat-tree .last-accordion-child,
:host .mat-tree .last-accordion-child {
  border-radius: var(--rounded-border-bottom);
}
shared-sidebar-list .mat-tree.tools-mode shared-sidebar-item .shared-sidebar-item:hover,
shared-sidebar-list .mat-tree.tools-mode shared-sidebar-item .shared-sidebar-item:focus,
:host .mat-tree.tools-mode shared-sidebar-item .shared-sidebar-item:hover,
:host .mat-tree.tools-mode shared-sidebar-item .shared-sidebar-item:focus {
  color: initial;
}
shared-sidebar-list .disabled,
:host .disabled {
  pointer-events: none;
}
/*# sourceMappingURL=shared-sidebar-list-56SQVGH2.css.map */
